export default "__VITE_ASSET__Vtv6tTf9__"